import React from 'react';
import {Route} from 'react-router-dom';

import {SurveyPage} from './surveyPage';

/** Renders routes to submit a survey for use as children on a react-router Switch. */
export const surveyRoutes = [
  <Route key="survey_v2" path="/v2/:company_slug/:msg_uid" element={<SurveyPage />} />,
  <Route key="survey" path="/:token" element={<SurveyPage />} />,
];
